import AdminConfirmatorPayments from './confirmators/page';
import AdminSellerPayments from './sallers/page';
import { useAuth } from "../../context/AuthProvider";

export default function PaymentsPage() {
  const { role } = useAuth();

  return (
    <div>
      {
        role === 3 ?
          <AdminConfirmatorPayments />
        : role === 0 ?
          <AdminSellerPayments />
        :
        ""
      }
    </div>
  )
}
